
<template>

   <div class="appearing main">

      <div class="main-container white-background">

         <div class='main-label black-color'>
            Succès
         </div>

         <p>La connexion avec le compte Fitbit a été réalisée avec succès</p>

         <v-btn class="close-btn" @click="close()">Cliquer ici</v-btn>
         
      </div>
    
   </div>
   
</template>

<script>
   export default {

      methods: {
         close: function() {
            window.close()
         }
      }
   }
</script>


<style scoped lang="scss" type="text/scss">

    $WIDTH: 400px;

   .main {
      display: flex;
      flex-direction: column;  
      align-items: center;
   }

   .main-container {
      flex: 1;
      width: $WIDTH;
      margin-top: 120px;
      margin-bottom: 30px;
      margin-left: 30px;
      margin-right: 30px;
      padding-bottom: 20px;
      padding-left: 20px;
      padding-right: 20px;
   }
   .white-background {
      background-color: white;
   }
   .main-label {
      text-align: center;
      color: #311217;
      font-size: 24px;
      margin-top: 30px;
      margin-bottom: 10px;
      letter-spacing: 0.2;
   }
   .black-color {
      color: gray;
   }
   .white-color {
      color: white;
   }

   .close-btn {
      text-align: center;
   }
</style>




// WEBPACK FOOTER //
// FitbitAuthorized.vue?48707748